<template>
  <div class="newidea"> 
    <div id="new-idea" class="col-sm-12">
      <div class="text">
        <textarea
          placeholder="Write an awesome idea"
          ref="contentTextArea"
          rows="1"
          v-model="title"
          @input="mixin_autoResize_resize"
          @focus="mixin_autoResize_resize"
        ></textarea>
      </div>
      <div class="close-icon" @click="close">
          <i class="icon-close"></i>
      </div>
      <div class="action-bar">
        <category-filter v-if="showCategories" label="Add category" v-model="categories"></category-filter>
        <accent-button title="Save" :act="unfocus"></accent-button>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "../bus";
import api from "../api";

import CategoryFilter from "./ideas/CategoryFilter"
import AccentButton from "./shared/AccentButton.vue"

import mixinAutoResize from "../mixins/autoResize.js";
import getMembersFromList from "../mixins/getMembersFromLists";

import createIdea from "../gql/ideas/createIdea.gql";
import createIdeasLists from "../gql/ideas_lists/createIdeasLists.gql";
// import getUserIdeas from "../gql/ideas/getUserIdeas.gql";
// import countUserIdeas from "../gql/ideas/countUserIdeas.gql";
import createIdeaCategories from "../gql/categories/createIdeaCategories.gql";

export default {
    components: {
    CategoryFilter,
    AccentButton
  },
  data() {
    return {
      title: "",
      categories: [],
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    showCategories() {
      return this.context && this.context == 'my-ideas';
    }
  },
  methods: {
    saveIdea: function () {
      if (!this.list) {
        this.savePrivateIdea();
      } else {
        let owner_id = this.user.id;
        let title = this.title;
        let status = "public";

        this.$apollo
          .mutate({
            mutation: createIdea,
            variables: {
              owner_id,
              title,
              status,
            },
          })
          .then((res) => {
            api.createEventTracking(
              "idea-created-public",
              "idea-created",
              this.user.id,
              true
            );

            let relationList = [];
            relationList.push({
              list_id: this.list.id,
              idea_id: res.data.insert_ideas_one.id,
            });

            const objects = relationList;
            this.$apollo
              .mutate({
                mutation: createIdeasLists,
                variables: {
                  objects,
                },
              })
              .then(() => {
                let newidea = {
                  id: res.data.insert_ideas_one.id,
                  title: title,
                  owner_id: this.user.id,
                  sumNegative: 0,
                  sumPostive: 0,
                };
                bus.$emit("idea-created-in-list", newidea);
                bus.$emit("new-idea-mode-inactive");
                this.title = "";
              });
          });
      }
    },
    addFocusEvent: function () {
      bus.$on("focus-textarea", () => {
        this.$refs.contentTextArea ? this.$refs.contentTextArea.focus() : "";
      });
      // window.addEventListener('touchup', (e) => {
      //   if (!this.$el.contains(e.target)){
      //     this.unfocus();
      //   }
      // })
    },
    unfocus: function () {
      if (this.title && this.title !== "") {
        this.saveIdea();
      } else {
        bus.$emit("new-idea-mode-inactive");
        this.title = "";
      }
    },
    close: function () {
      bus.$emit("new-idea-mode-inactive");
    },
    savePrivateIdea: function() {
       let owner_id = this.user.id;
        let title = this.title;
        let status = "private";

        this.$apollo
          .mutate({
            mutation: createIdea,
            variables: {
              owner_id,
              title,
              status,
            },
          })
          .then((data) => {
            api.createEventTracking(
              "idea-created-private",
              "idea-created",
              this.user.id,
              true
            );
            if(this.categories.length) {
              this.saveCategories(data.data.insert_ideas_one.id)
            } else {
              bus.$emit("new-idea-mode-inactive");
            }
          });
    }, 
    saveCategories: function(ideaId) {
      for(let i=0; i<this.categories.length; i++) {
        const categoryId = this.categories[i].id;
        this.$apollo
          .mutate({
            mutation: createIdeaCategories,
            variables: {
              ideaId,
              categoryId
            }
          })
          .then(()=>{
            bus.$emit("new-idea-mode-inactive");
          });
      }
    }
  },
  mounted() {
    this.addFocusEvent();
  },
  props: {
    list: {
      type: Object,
      required: false,
    },
    context: {
      type: String, 
      required: false,
      default: 'my-ideas'
    }
  },
  mixins: [mixinAutoResize, getMembersFromList],
};
</script>

<style scoped lang="scss">
@use '../styles/theme.scss';

#new-idea {
  // margin: auto;
  margin-bottom: 10px;
  background: theme.$white-background;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 16px 12px;
  text-align: left;
  border-left: 4px solid theme.$accent-color;
}
#new-idea * {
  display: inline;
  vertical-align: middle;
}

#new-idea textarea {
  outline: none;
  max-height: 150px;
  resize: vertical;
  font-size: 14px;
  font-weight: 200;
  border: none;
  padding: 0px;
  min-height: 1em;
  width: calc(100% - 36px);
}

#new-idea .icon-plus {
  font-size: 28px;
  margin-left: 5px;
  line-height: 1em;
}

#new-idea .icon-plus span {
  text-align: right;
}

#new-idea .action-bar {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  font-size: 12px;
}
.action-bar .accent-button {
  align-self: flex-start;
}

.close-icon {
  position: absolute;
  right: 0px;
  top: 0px;
  padding: 6px 12px;
  font-size: 20px;
}
</style>